import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Header from "src/components/common/Header";
import Sidebar from "src/components/common/Sidebar";
import { useAppRodeoEventSettingsSelector } from "src/_common/hooks/selectors/eventSelector";
// import { useAppPerformanceInfoSelector, useAppPerformanceListSelector, useAppRodeoEventSettingsSelector } from "src/_common/hooks/selectors/eventSelector";
import { CRYPTO_SECRET_KEY, RODEO_PAGE_NAME, URLS } from "src/_config";
import Sponsor from "src/components/common/Sponsor";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function PrizesListPage() {
  const history = useHistory();
  const { eventId, performanceId } = useParams<any>();
  const rodeoEventSettings = useAppRodeoEventSettingsSelector();
  const types = ["Game", "Event", "Performance"];

  const gotoPrizeDetailsPage = (type: any) => {
    history.push(`/prize/${eventId}/${performanceId}/${cryptr.encrypt(type)}`);
  };

  const gotoEventPage = () => {
    history.push(`/event/${eventId}/${performanceId}`);
  };

  const gotoPerformancesPage = () => {
    history.push(`/performances/${eventId}`);
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <h2 className="page-title text-left">
        <a onClick={gotoPerformancesPage} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </a>
        Prizes
        <hr className="color-white" />
      </h2>
      <ul className="list-style rodeo-inside-list mt-4">
        {types.map((type: any, i: any) =>
          rodeoEventSettings["is_" + type.toLowerCase() + "_prize"] ? (
            <li key={i}>
              <a className={"ripple-effect d-flex"} onClick={() => gotoPrizeDetailsPage(type)}>
                <span>
                  <i
                    className={type == "Game" ? "fas fa-trophy" : type == "Performance" ? "fa fa-shield" : "fa fa-flag"}
                    style={{ fontSize: "25px" }}
                  />
                </span>
                <span className="event-info">
                  <span className="d-inline-block event-title">{type} Prize</span>
                </span>
              </a>
            </li>
          ) : null
        )}
      </ul>
      <div className="join-now-btn-wrap">
        <button className="w-100" onClick={gotoEventPage}>
          Play Now
        </button>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
